export default "__VITE_ASSET__711475fd__"